import {
  GraphQLFieldConfig,
  GraphQLNonNull,
  GraphQLString,
  GraphQLObjectType,
  GraphQLFloat
} from 'graphql'
import { Context } from '../shared'

interface Args {
  readonly organizationID: string
}

export const serverlessAccessToken: GraphQLFieldConfig<any, Context, Args> = {
  description: 'Get access token for serverless service.',
  type: new GraphQLObjectType({
    name: 'ServerlessAccessToken',
    description:
      'Serverless access token contains fields necessary to bootstrap the Serverless micro-frontend.',
    fields: () => ({
      accessToken: {
        type: new GraphQLNonNull(GraphQLString)
      },
      expiresAt: {
        type: new GraphQLNonNull(GraphQLFloat)
      },
      host: {
        type: new GraphQLNonNull(GraphQLString)
      },
      remoteEntry: {
        type: new GraphQLNonNull(GraphQLString)
      }
    })
  }),
  args: {
    organizationID: {
      type: new GraphQLNonNull(GraphQLString)
    }
  },
  async resolve(_source, args, context): Promise<{ readonly tags: string[] }> {
    const { organizationID } = args
    const { connector } = context

    return connector.get(`organizations/${organizationID}/serverless/tokens`)
  }
}
